import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Resetea scroll en todos los navegadores
    document.documentElement.scrollTop = 0; // Chrome, Safari, …
    document.body.scrollTop = 0;             // Firefox
  }, [pathname]);

  return null; // ya no envuelve children
};

export default ScrollToTop;
